module.exports = __webpack_public_path__ + "static/media/admin-scale.1a1168e6.svg";